import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { List } from 'react-virtualized';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import ModalD from 'react-awesome-modal';
import {connect}  from  "react-redux";
import {BeatLoader} from "react-spinners";
import {css} from "@emotion/core";
import {confirmAlert} from 'react-confirm-alert';
import { isApiResponse, isReportAccess, date_range_config, aplloClient, user_activities } from '../../helpers/utils.js';
import DateRangeFilter from '../../filters/DateRangeFilter.jsx';
import DownloadAllReport from '../DownloadReport/DownloadAllReport.jsx';
import MerchantFilter from '../../filters/MerchantFilter.jsx';
import ChainFilter from '../../filters/ChainFilter.jsx';
import StoreFilter from '../../filters/StoreFilter.jsx';
import CityFilter from '../../filters/CityFilter.jsx';
import CardTypeFilter from '../../filters/CardTypeFilter.jsx';
import AcquirerFilter from '../../filters/AcquirerFilter.jsx';
import IndustryCategoryFilter from '../../filters/IndustryCategoryFilter.jsx';
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;

var date_config = date_range_config('1', '1', '2020-02-01','1');
var DccSettTable='';

class DccSettlementReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            merchantList:[],
            chainList:[],
            merchantID:'',
            chainID:'',
            storeID:'',
            merchantValue:null,
            chainValue:null,
            storeList:[],
            acqBankList:[],
            acqBankValue: null,
            acqBankIds:'',
            issuerBankList:[],
            issuerBankValue:null,
            issuerBankIds:'',
            cityLists:[],
            cityValue:null,
            cityIds:'',
            loading:false,
            model_visible : false,
            file_url: '',
            rfile: '',
            merchant_list_box: false,
            chain_list_box: false,
            store_list_box: false,
            acq_bank_list_box: false,
            cardTypeLists:[],
            cardTypeValue:'',
            cardTypeIDs:'',
            is_store_loading: true,
            is_chain_loading: true,
            is_merchant_loading: true,
            isChange: false,
            storeListOpen: false,
            storeHeaderTitle: "Select [Store]",
            object_code:[],
            storeObject:[],
            search_object_code:[],
            fetch_data:false,
            industryCategoryList:[],
            industryCategoryValue: null,
            industryCategoryIds:''
        }
    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        isReportAccess(AllAccessPermissions, 'daily_settlement');
        if(decoded.object_type==='Merchant'){
            this.setState({
                merchantID: arrayCode
            })
        }
        if(decoded.object_type==='Chain'){
            this.setState({
                chainID: arrayCode
            })
        }
        if(decoded.object_type==='Store'){
            this.setState({
                storeID: arrayCode
            })
        }

        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
        });
    }

    componentDidUpdate() {

    }
    componentDidMount() {
        this.get_filtered_dcc_settlement_report(this.state.object_type,this.state.object_code,'');
        user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'dcc_daily_settlement_report','sparcs')
    }

    downLoadDccSettlementReportCheck(){
        let transaction_type = this.state.transaction_type;
        if (Array.isArray(this.state.transaction_type) && this.state.transaction_type.includes("all") === true) {
            transaction_type = []
        }
        let filters = {
            merchant_codes: this.state.merchantID,
            chain_codes: this.state.chainID,
            store_codes: this.state.storeID,
            acq_bank_codes: this.state.acqBankIds,
            city: this.state.cityIds,
            start_date: this.state.yestSend,
            end_date: this.state.todSend,
            industry_code: this.state.industryCategoryIds,
            card_type: this.state.schemeIDs,
            txn_type: 'DCC',
            download: 1
        }
        this.setState({
            filters:filters
        })
        if(this.state.merchantID==='' && this.state.chainID==='' && this.state.storeID===''&& this.state.acqBankIds==='' && this.state.cityIds==='' && this.state.cardTypeIDs===''){
            confirmAlert({
            //title: 'Warning',
                message: "Do you really want to download all data for date range: "+this.state.datefromShow+" - "+this.state.dateToShow+" ? This will take some time to download depending on volume of data. Alternatively, please apply a filter.",
                buttons: [{
                    label: 'OK',
                    onClick: () => {
                        this.refs.downloadAllReport.downLoadReport(filters, '/report/settlement/daily/categories','dcc_daily_settlement_report');
                    }
                },
                    {
                        label: 'Cancel',
                    }
                ]
            });
        } else {
            this.refs.downloadAllReport.downLoadReport(filters, '/report/settlement/daily/categories','dcc_daily_settlement_report');
        }
    }
    get_filtered_dcc_settlement_report(object_type, object_code, event) {
        isApiResponse(false)
        if ($.fn.DataTable.isDataTable('#DccSettTable')) {
            $('#DccSettTable').DataTable().clear().destroy();
        }
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
        if(object_type === 'Merchant' && this.state.merchantID===''){
            merchants = object_code;

        }
        if(object_type==='Chain' && this.state.chainID===''){
            chains = object_code;
        }
        if(object_type==='Store' && this.state.storeID===''){
            stores = object_code;
        }
        this.setState({
            active_mids:merchants,
            active_cids: chains,
            active_sids: stores,
            active_bids: this.state.acqBankIds,
            active_cityids: this.state.cityIds,
            active_yestSend: this.state.yestSend,
            active_todSend: this.state.todSend,
            active_card_type: this.state.cardTypeIDs,
        })
        var postData = {
            mids: merchants,
            cids: chains,
            sids: stores,
            bids: this.state.acqBankIds,
            cityids: this.state.cityIds,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            card_type: this.state.cardTypeIDs,
            txn_type: 'DCC',
            industry_code: this.state.industryCategoryIds
        };
        var DccSalesReports = $('#DccSettTable').DataTable(
            {
                order:[],
                // "dom": 'fltip',
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                //"autoWidth": false,
                "responsive": false,
                "scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/reports/daily-settlement-reports-categories",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) {
                        isApiResponse(true);
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                        alert("Failed to load data. Please try again");
                    },
                    complete: function (data) {
                        isApiResponse(true);
                    },
                },

                columns: [
                    {"data":"Merchant", "width": "150px"},
                    {"data":"Store Name", "width": "100px"},
                    {"data":"Pincode", "width": "50px"},
                    {"data":"City", "width": "50px"},
                    {"data":"Acquirer Bank","width": "50px"},
                    {"data":"Utid"},
                    {"data":"Btid"},
                    {"data":"Settlement Date"},
                    {"data":"Total Settled Transactions"},
                    {"data":"Total Settled Amount"},
                    {"data":"Total Unsettled Transactions"},
                    {"data":"Industry Category"}
                ],
                "columnDefs": [
                    {
                        width: "150px",
                        targets: 0,
                    },
                    {
                        width: "130px",
                        targets: 1,
                    },

                    {  render: function (data) {
                            return '<td >'+moment(data).format('D MMM YYYY')+'</td>';
                        },
                        "width": "90px",
                        "targets": 7
                    },
                    {
                       "targets": 10,
                       "orderable": false
                    },

                ]
            });
    }
    reset_all(e){
        this.refs.daterangeFilter.restDateFilter(date_config.start_date,date_config.end_date,date_config.display_start_date, date_config.display_end_date, date_config.start_date_value,date_config.end_date_value);
        if(this.state.object_type==='Innoviti')
        {
            this.refs.merchantFilter.restMerchantFilter();
            this.refs.reloadChain.getChain(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code);
            this.refs.reloadStore.getStore(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code, false,'');
//             this.refs.reloadUtid.ci_utid('','','',false,'');
        }
        if(this.state.object_type==='Merchant')
        {
            this.refs.reloadChain.getChain(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code);
            this.refs.reloadStore.getStore(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code,false,'');
//             this.refs.reloadUtid.ci_utid(this.state.object_code,'','',false,'');
        }
        if(this.state.object_type==='Chain')
        {
            this.refs.reloadStore.getStore(this.state.object_code, 'chain', this.state.object_type, this.state.object_code,false,'');

        }

        this.refs.cityFilter.resetCityFilter();
        this.refs.acquirerFilter.resetAcquirerFilter();
        this.refs.industryCategoryFilter.resetIndustryCategoryFilter();
        this.refs.cardTypeFilter._get_card_type(date_config.start_date_value, date_config.end_date_value);
        this.setState({
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            merchantID:'',
            chainID:'',
            storeID:'',
            storeValue:[],
            merchantValue:[],
            chainValue:[],
            acqBankValue: [],
            acqBankIds:'',
            issuerBankValue:[],
            issuerBankIds:'',
            cityValue:[],
            cityIds:'',
            is_void:1,
            file_url: '',
            rfile: '',
            cardGradeValue:[],
            cardGradeIDs:'',
            schemeValue:[],
            schemeIDs:'',
            cardTypeValue:[],
            cardTypeIDs:'',
            txnissuerValue:[],
            txnissuerIDs:'',
            emiIssuerValue:[],
            emiIssuerIDs:'',
            txnTypeIDs: ['SALE'],
            txnTypeValue: [{value: "SALE", label: "SALE"}],
            ciutidValue: [],
            ciutidIds: '',
            isSettledIDs: '',
            isSettledValue: [],
            isChange: false,
            is_posbillinput: 0,
            is_prim_id:0,
            tenderModeIDs:'',
            tenderModeValue:[],
            is_fallback: 0,
            traCurrencyValue:[],
            traCurrencyIDs:'',
            issuHomeCurrValue:[],
            issuHomeCurrIDs:'',
            campaignCodeValue:[],
            campaignCodeIDs:'',
            industryCategoryIds:'',
        })

        setTimeout(function(){
            this.componentWillMount()
            this.componentDidMount()
        }.bind(this), 200);
    }

    handleDateRange = (todSend, yestSend, datefromShow,dateToShow) =>
    {
        this.setState({
            todSend: todSend,
            yestSend: yestSend,
            datefromShow: datefromShow,
            dateToShow: dateToShow,
            isChange: true,
        });
        this.refs.cardTypeFilter._get_card_type(yestSend, todSend);

    }
    handleMerchant = (optionSelected, merchantID) =>
    {
        this.setState({
            merchantID:merchantID,
            isChange: true,
            chainID:'',
            storeID:'',
            ciutidIds: '',
        });
        this.refs.reloadChain.getChain(merchantID, 'merchant', this.state.object_type, this.state.object_code);
        this.refs.reloadStore.getStore(merchantID, 'merchant', this.state.object_type, this.state.object_code,false,'');
//         this.refs.reloadUtid.ci_utid(merchantID, '','',false,'');
    }
    handleChain = (optionSelected, chainID) =>
    {
        this.setState({
            chainID:chainID,
            isChange: true,
            storeID:'',
            ciutidIds: '',
        });
        this.refs.reloadStore.getStore(chainID, 'chain', this.state.object_type, this.state.merchantID,false,'');
//         this.refs.reloadUtid.ci_utid(this.state.merchantID, chainID,'',false,'');
    }

    handleStore = (storeID) =>
    {
        this.setState({
            storeID:storeID,
            isChange: true,
            ciutidIds: '',

        });
//         this.refs.reloadUtid.ci_utid(this.state.merchantID, this.state.chainID,storeID,false,'');
    }

    handleCity = (optionSelected, cityIds) =>
    {
        this.setState({
            cityIds:cityIds,
            isChange: true
        });
    }
    handleAcquirer = (optionSelected, acqBankIds) =>
    {
        this.setState({
            acqBankIds:acqBankIds,
            isChange: true
        });
    }
    handleIndustryCategoryFilter = (optionSelected, industryCategoryIds) =>
    {
        this.setState({
            industryCategoryIds:industryCategoryIds,
            isChange: true
        });
    }
    handleCardType = (optionSelected, ceditArray) =>
    {
        this.setState({
            cardTypeIDs:ceditArray,
            isChange: true
        });
    }

    render() {
        return(
          
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">DCC Daily Settlement Report</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    {/*<div className="row">*/}
                                    <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                        <div><label> Date Filter: </label></div>
                                        <DateRangeFilter ref="daterangeFilter" onSelectDate = {this.handleDateRange} start_date = {this.state.datefrom} end_date={this.state.dateTo} display_start_date = {this.state.datefromShow} display_end_date = {this.state.dateToShow}
                                                start_date_limit = {this.state.dateFromLimit} end_date_limit = {this.state.dateLimit}/>
                                    </div>
                                   {this.state.object_type ==='Innoviti'?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label>Merchants</label>
                                                    <MerchantFilter ref="merchantFilter" onSelectMerchant = {this.handleMerchant} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div> : null}
                                            {this.state.object_type ==='Innoviti' || this.state.object_type ==='Merchant'?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label> Chain </label>
                                                    <ChainFilter ref= "reloadChain" onSelectChain = {this.handleChain} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null }
                                            {this.state.object_type ==='Innoviti' || this.state.object_type ==='Merchant' || this.state.object_type ==='Chain'?
                                                <div className="col-md-2 filter-bottom5 padd-5" >
                                                    <label> Store: </label>
                                                    <StoreFilter ref= "reloadStore" onSelectStore = {this.handleStore} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null }
{/*                                     {this.state.acq_bank_list_box===true? */}
                                        <div className="col-md-2 filter-bottom5 padd-5">
                                            <label>Acquirer:</label>
                                            <AcquirerFilter ref="acquirerFilter" onSelectAcquirer = {this.handleAcquirer}/>
                                            <div className="clearfix"></div>
                                        </div>
{/*                                         : null } */}
                                        <div className="col-md-2 filter-bottom5 padd-5">
                                            <label> City: </label>
                                            <CityFilter ref="cityFilter" onSelectCity = {this.handleCity}/>
                                            <div className="clearfix"></div>
                                        </div>
                                        <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Card Type: </label>
                                                <CardTypeFilter ref= "cardTypeFilter" onSelectCardType = {this.handleCardType} start_date = {this.state.yestSend} end_date={this.state.todSend}/>
                                                <div className="clearfix"></div>
                                        </div>
                                        <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Industry Category: </label>
                                                 <IndustryCategoryFilter ref="industryCategoryFilter" onSelectIndustryCategoryFilter = {this.handleIndustryCategoryFilter}/>
                                                  <div className="clearfix"></div>
                                            </div>
                                    <div className="col-md-5 pull-right">
                                        {this.state.isChange===true?
                                            <span className="apply-notification">Please click on Apply button</span>:null
                                        }
                                        <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this.get_filtered_dcc_settlement_report.bind(this, this.state.object_type,this.state.object_code)}>Apply</button>
                                        <button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>
                                    </div>

                                    {/*</div>*/}
                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    <div className="">
                                        <a href="#" className="exportButton" role="button" onClick={this.downLoadDccSettlementReportCheck.bind(this)}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Export to CSV
                                        </a>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <table id="DccSettTable" className="table table-striped table-hover">
                                            <thead>
                                            <tr>
                                                <th>Merchant</th>
                                                <th>Store Name</th>
                                                <th>Pin Code</th>
                                                <th>City</th>
                                                <th>Acquirer Bank</th>
                                                <th>Utid</th>
                                                <th>Btid</th>
                                                <th>Settlement Date</th>
                                                <th>Total Settled Transactions</th>
                                                <th>Total Settled Amount</th>
                                                <th>Total Unsettled Transactions</th>
                                                <th>Industry Category</th>
                                            </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                     <DownloadAllReport ref="downloadAllReport" />

                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           
        );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)(DccSettlementReport)